// Ids 1-4 match M5 seed (20260729190000_firestore_migration_seeds); 5 was added by
// pricing_engine_v2. Priority order for price resolution is narrowest-wins:
// ACCOUNT_PRODUCT > ACCOUNT > PRODUCT > MARKET > CATEGORY_DEFAULT.
export var PriceScopeType;
(function (PriceScopeType) {
    PriceScopeType[PriceScopeType["CATEGORY_DEFAULT"] = 1] = "CATEGORY_DEFAULT";
    PriceScopeType[PriceScopeType["MARKET"] = 2] = "MARKET";
    PriceScopeType[PriceScopeType["PRODUCT"] = 3] = "PRODUCT";
    PriceScopeType[PriceScopeType["ACCOUNT"] = 4] = "ACCOUNT";
    PriceScopeType[PriceScopeType["ACCOUNT_PRODUCT"] = 5] = "ACCOUNT_PRODUCT";
})(PriceScopeType || (PriceScopeType = {}));
//# sourceMappingURL=price-scope-type.js.map